import { FormConfig, useEolasForm } from "Hooks/useEolasForm";
import { FieldValues } from "react-hook-form";
import { FormValues, FormElement } from "modules/portfolio/types";
import { makeValidationSchema } from "./helpers";

interface UseNewEventFormProps<T> extends Omit<FormConfig<T>, "validationSchema"> {
  formElements: FormElement[];
}

const useEventForm = ({ formElements, defaultValues }: UseNewEventFormProps<FormValues>) => {
  const validationSchema = makeValidationSchema({ formElements });
  const formData = useEolasForm<FieldValues>({ validationSchema, defaultValues });
  return formData;
};
export default useEventForm;
